// import React, { useState } from "react";
// import { Footer, Navbar } from "../components";
// import { Link } from 'react-router-dom';
// import { useNavigate } from "react-router-dom";
// const Register = () => {
//     const [fullname, setfullName] = useState("");
//     const [email, setEmail] = useState("");
//     const [password, setPassword] = useState("");
//    const [updateFormData] = React.useState([]);
//    const navigate=useNavigate();

//     let Submit=(e)=>{
//         e.preventDefault();
//         const newEntry ={
//             fullname:fullname,
//             email:email,
//             password:password
//         }
       
//         updateFormData([newEntry])
//        // console.log(formData)
//        if(fullname==='' || email==='' || password==='') return window.alert("Please fill out the field first")
//             const params={
//             method:'post',
//             headers:{
//                 'Content-Type':'application/json'
//             },
//             body:JSON.stringify(newEntry)
//         }
//         fetch("https://shopping-site-backend-13q4.onrender.com/api/login",params).then((res)=>{
//             return res.json()
//         }).then((data)=>{
//             console.log(data);
//             window.alert("Registration successful");
//             navigate('/login')
//         })       
//      }
//     return (
//         <>
//             <Navbar />
//             <div className="container my-3 py-3">
//                 <h1 className="text-center">Register</h1>
//                 <hr />
//                 <div className="row my-4 h-100">
//                     <div className="col-md-4 col-lg-4 col-sm-8 mx-auto">
//                         <form onSubmit={Submit}>
//                             <div className="form my-3">
//                                 <label htmlFor="Name">Full Name</label>
//                                 <input value={fullname} onChange={(e)=>{setfullName(e.target.value)}} type="fullname" placeholder="Enter your Full name" />
//                             </div>
//                             <div className="form my-3">
//                                 <label htmlFor="Email">Email address</label>
//                                 <input value={email} onChange={(e)=>{setEmail(e.target.value)}} type="email" placeholder="Enter your email"  />
//                             </div>
//                             <div className="form  my-3">
//                                 <label htmlFor="Password">Password</label>
//                                 <input value={password} onChange={(e)=>{setPassword(e.target.value)}} type="password" placeholder="Enter your password" />
//                             </div>
//                             <div className="my-3">
//                                 <p>Already has an account? <Link to="/login" className="text-decoration-underline text-info">Login</Link> </p>
//                             </div>
//                             <div className="text-center">
//                                 <button className="my-2 mx-auto btn btn-dark">
//                                     Register
//                                 </button>
//                             </div>
//                         </form>
//                     </div>
//                 </div>
//             </div>
//             <Footer />
//         </>
//     )
// }

// export default Register


// import React, { useState } from "react";
// import { Footer } from "../components";
// import { Link } from 'react-router-dom';
// import { useNavigate } from "react-router-dom";

// const Register = () => {
//     const [fullname, setfullName] = useState("");
//     const [email, setEmail] = useState("");
//     const [password, setPassword] = useState("");
//     const navigate = useNavigate();

//     const Submit = (e) => {
//         e.preventDefault();
//         const newEntry = {
//             fullname: fullname,
//             email: email,
//             password: password
//         };

//         if (fullname === '' || email === '' || password === ''){
//             return window.alert("Please fill out all the fields first");
//         }
      
//         const params = {
//             method: 'post',
//             headers: {
//                 'Content-Type': 'application/json'
//             },
//             body: JSON.stringify(newEntry)
//         };

//         fetch("https://shopping-site-backend-m1ok.onrender.com/api/register", params)
//             .then((res) => res.json())
//             .then((data) => {
//                 console.log(data);
//                 window.alert("Registration successful");
//                 navigate('/login');
//             })
//             .catch((error) => {
//                 console.error(error);
//                 window.alert("Error occurred during registration");
//             });
//     };

//     return (
//         <>
            
//             <div className="container my-3 py-3">
//                 <h1 className="text-center">Register</h1>
//                 <hr />
//                 <div className="row my-4 h-100">
//                     <div className="col-md-4 col-lg-4 col-sm-8 mx-auto">
//                         <form onSubmit={Submit}>
//                             <div className="form my-3">
//                                 <label htmlFor="Name">Full Name</label>
//                                 <input
//                                     value={fullname}
//                                     onChange={(e) => setfullName(e.target.value)}
//                                     type="fullname"
//                                     placeholder="Enter your Full name"
//                                 />
//                             </div>
//                             <div className="form my-3">
//                                 <label htmlFor="Email">Email address</label>
//                                 <input
//                                     value={email}
//                                     onChange={(e) => setEmail(e.target.value)}
//                                     type="email"
//                                     placeholder="Enter your email"
//                                 />
//                             </div>
//                             <div className="form  my-3">
//                                 <label htmlFor="Password">Password</label>
//                                 <input
//                                     value={password}
//                                     onChange={(e) => setPassword(e.target.value)}
//                                     type="password"
//                                     placeholder="Enter your password"
//                                 />
//                             </div>
//                             <div className="my-3">
//                                 <p>Already has an account? <Link to="/login" className="text-decoration-underline text-info">Login</Link> </p>
//                             </div>
//                             <div className="text-center">
//                                 <button className="my-2 mx-auto btn btn-dark">
//                                     Register
//                                 </button>
//                             </div>
//                         </form>
//                     </div>
//                 </div>
//             </div>
//             <Footer />
//         </>
//     );
// };

// export default Register;



// import React, { useState } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import { Footer, Navbar } from "../components";

// const Register = () => {
//     const [fullname, setfullName] = useState("");
//     const [email, setEmail] = useState("");
//     const [password, setPassword] = useState("");
//     const navigate = useNavigate();

//     const handleSubmit = (e) => {
//         e.preventDefault();
//         const newEntry = {
//             fullname: fullname,
//             email: email,
//             password: password
//         };

//         if (fullname === '' || email === '' || password === ''){
//             return window.alert("Please fill out all the fields first");
//         }
      
//         const params = {
//             method: 'post',
//             headers: {
//                 'Content-Type': 'application/json'
//             },
//             body: JSON.stringify(newEntry)
//         };

//         fetch("https://shopping-site-backend-k2t2.onrender.com/api/register", params)
//             .then((res) => res.json())
//             .then((data) => {
//                 console.log(data);
//                 window.alert("Registration successful");
//                 navigate('/login');
//             })
//             .catch((error) => {
//                 console.error(error);
//                 window.alert("Error occurred during registration");
//             });
//     };

//     return (
//         <>
//             <Navbar />
//             <div className="container my-3 py-3">
//                 <h1 className="text-center">Register</h1>
//                 <hr />
//                 <div className="row my-4 h-100">
//                     <div className="col-md-4 col-lg-4 col-sm-8 mx-auto">
//                         <form onSubmit={handleSubmit}>
//                             <div className="form my-3">
//                                 <label htmlFor="Name">Full Name</label>
//                                 <input
//                                     type="text"
//                                     className="form-control"
//                                     id="Name"
//                                     placeholder="Enter Your Name"
//                                     value={fullname}
//                                     onChange={(e) => setfullName(e.target.value)}
//                                 />
//                             </div>
//                             <div className="form my-3">
//                                 <label htmlFor="Email">Email address</label>
//                                 <input
//                                     type="email"
//                                     className="form-control"
//                                     id="Email"
//                                     placeholder="name@example.com"
//                                     value={email}
//                                     onChange={(e) => setEmail(e.target.value)}
//                                 />
//                             </div>
//                             <div className="form my-3">
//                                 <label htmlFor="Password">Password</label>
//                                 <input
//                                     type="password"
//                                     className="form-control"
//                                     id="Password"
//                                     placeholder="Password"
//                                     value={password}
//                                     onChange={(e) => setPassword(e.target.value)}
//                                 />
//                             </div>
//                             <div className="my-3">
//                                 <p>Already have an account? <Link to="/login" className="text-decoration-underline text-info">Login</Link> </p>
//                             </div>
//                             <div className="text-center">
//                                 <button className="my-2 mx-auto btn btn-dark" type="submit">
//                                     Register
//                                 </button>
//                             </div>
//                         </form>
//                     </div>
//                 </div>
//             </div>
//             <Footer />
//         </>
//     )
// }

// export default Register;

import React, { useState, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Footer, Navbar } from "../components";
import { AuthContext } from "../context/AuthContext";

const Register = () => {
  const [fullname, setFullname] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const { register } = useContext(AuthContext);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newEntry = { fullname, email, password };

    if (fullname === '' || email === '' || password === ''){
      return window.alert("Please fill out all the fields first");
    }
  
    const url = "https://shopping-site-backend-k2t2.onrender.com/api/register";
    const params = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(newEntry)
    };

    try {
      const res = await fetch(url, params);
      const data = await res.json();

      if (!res.ok) {
        throw new Error(data.error || 'Registration failed');
      }

      if (data.accessToken) {
        register(data.accessToken);
        navigate('/login');
      } else {
        window.alert("Registration failed");
      }
    } catch (error) {
      console.error("Error during registration:", error);
      window.alert(error.message);
    }
  };

  return (
    <>
      <Navbar />
      <div className="container my-3 py-3">
        <h1 className="text-center">Register</h1>
        <hr />
        <div className="row my-4 h-100">
          <div className="col-md-4 col-lg-4 col-sm-8 mx-auto">
            <form onSubmit={handleSubmit}>
              <div className="form my-3">
                <label htmlFor="Name">Full Name</label>
                <input
                  type="text"
                  className="form-control"
                  id="Name"
                  placeholder="Enter Your Name"
                  value={fullname}
                  onChange={(e) => setFullname(e.target.value)}
                />
              </div>
              <div className="form my-3">
                <label htmlFor="Email">Email address</label>
                <input
                  type="email"
                  className="form-control"
                  id="Email"
                  placeholder="name@example.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
              <div className="form my-3">
                <label htmlFor="Password">Password</label>
                <input
                  type="password"
                  className="form-control"
                  id="Password"
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div>
              <div className="my-3">
                <p>Already have an account? <Link to="/login" className="text-decoration-underline text-info">Login</Link> </p>
              </div>
              <div className="text-center">
                <button className="my-2 mx-auto btn btn-dark" type="submit">
                  Register
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Register;






// import React, { useState, useContext } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import { Footer, Navbar } from "../components";
// import { AuthContext } from "../context/AuthContext";

// const Register = () => {
//   const [fullname, setFullName] = useState("");
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const navigate = useNavigate();
//   const { register } = useContext(AuthContext);

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     const newEntry = {
//       fullname,
//       email,
//       password,
//     };

//     if (fullname === '' || email === '' || password === '') {
//       return window.alert("Please fill out all the fields first");
//     }

//     const params = {
//       method: 'post',
//       headers: {
//         'Content-Type': 'application/json',
//       },
//       body: JSON.stringify(newEntry),
//     };
    
    
//     fetch("https://shopping-site-backend-13q4.onrender.com/api/login", params)
//       .then((res) => res.json())
//       .then((data) => {
//         if (data.message !== "Registration successful") {
//           return window.alert(data.message || "Registration failed");
//         }
//         register(data.token); // Assuming the API returns a token
//         window.alert("Registration successful");
//         navigate('/login');
//       })
//       .catch((error) => {
//         console.error(error);
//         window.alert("Error occurred during registration");
//       });
//   };

//   return (
//     <>
//       <Navbar />
//       <div className="container my-3 py-3">
//         <h1 className="text-center">Register</h1>
//         <hr />
//         <div className="row my-4 h-100">
//           <div className="col-md-4 col-lg-4 col-sm-8 mx-auto">
//             <form onSubmit={handleSubmit}>
//               <div className="form my-3">
//                 <label htmlFor="Name">Full Name</label>
//                 <input
//                   type="text"
//                   className="form-control"
//                   id="Name"
//                   placeholder="Enter Your Name"
//                   value={fullname}
//                   onChange={(e) => setFullName(e.target.value)}
//                 />
//               </div>
//               <div className="form my-3">
//                 <label htmlFor="Email">Email address</label>
//                 <input
//                   type="email"
//                   className="form-control"
//                   id="Email"
//                   placeholder="name@example.com"
//                   value={email}
//                   onChange={(e) => setEmail(e.target.value)}
//                 />
//               </div>
//               <div className="form my-3">
//                 <label htmlFor="Password">Password</label>
//                 <input
//                   type="password"
//                   className="form-control"
//                   id="Password"
//                   placeholder="Password"
//                   value={password}
//                   onChange={(e) => setPassword(e.target.value)}
//                 />
//               </div>
//               <div className="my-3">
//                 <p>Already have an account? <Link to="/login" className="text-decoration-underline text-info">Login</Link></p>
//               </div>
//               <div className="text-center">
//                 <button className="my-2 mx-auto btn btn-dark" type="submit">
//                   Register
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       </div>
//       <Footer />
//     </>
//   );
// };

// export default Register;


// import React, { useState, useContext } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import { AuthContext } from "../context/AuthContext";

// const Register = () => {
//   const [fullname, setFullName] = useState("");
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const navigate = useNavigate();
//   const { register } = useContext(AuthContext);

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     const newEntry = {
//       fullname,
//       email,
//       password,
//     };

//     if (fullname === '' || email === '' || password === '') {
//       return window.alert("Please fill out all the fields first");
//     }

//     const params = {
//       method: 'post',
//       headers: {
//         'Content-Type': 'application/json',
//       },
//       body: JSON.stringify(newEntry),
//     };

//     fetch("https://shopping-site-backend-13q4.onrender.com/api/login", params)
//       .then((res) => res.json())
//       .then((data) => {
//         if (data.message !== "Registration successful") {
//           return window.alert(data.message || "Registration failed");
//         }
//         window.alert("Registration successful");
//         navigate('/login');
//       })
//       .catch((error) => {
//         console.error(error);
//         window.alert("Error occurred during registration");
//       });
//   };

//   return (
//     <div className="container my-3 py-3">
//       <h1 className="text-center">Register</h1>
//       <hr />
//       <div className="row my-4 h-100">
//         <div className="col-md-4 col-lg-4 col-sm-8 mx-auto">
//           <form onSubmit={handleSubmit}>
//             <div className="form my-3">
//               <label htmlFor="Name">Full Name</label>
//               <input
//                 type="text"
//                 className="form-control"
//                 id="Name"
//                 placeholder="Enter Your Name"
//                 value={fullname}
//                 onChange={(e) => setFullName(e.target.value)}
//               />
//             </div>
//             <div className="form my-3">
//               <label htmlFor="Email">Email address</label>
//               <input
//                 type="email"
//                 className="form-control"
//                 id="Email"
//                 placeholder="name@example.com"
//                 value={email}
//                 onChange={(e) => setEmail(e.target.value)}
//               />
//             </div>
//             <div className="form my-3">
//               <label htmlFor="Password">Password</label>
//               <input
//                 type="password"
//                 className="form-control"
//                 id="Password"
//                 placeholder="Password"
//                 value={password}
//                 onChange={(e) => setPassword(e.target.value)}
//               />
//             </div>
//             <div className="my-3">
//               <p>Already have an account? <Link to="/login" className="text-decoration-underline text-info">Login</Link></p>
//             </div>
//             <div className="text-center">
//               <button className="my-2 mx-auto btn btn-dark" type="submit">
//                 Register
//               </button>
//             </div>
//           </form>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Register;




// import React, { useState, useContext } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import { AuthContext } from "../context/AuthContext";

// const Register = () => {
//   const [fullname, setFullName] = useState("");
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const navigate = useNavigate();
//   const { register } = useContext(AuthContext);

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     const newEntry = {
//       fullname,
//       email,
//       password,
//     };

//     if (fullname === '' || email === '' || password === '') {
//       return window.alert("Please fill out all the fields first");
//     }

//     const params = {
//       method: 'post',
//       headers: {
//         'Content-Type': 'application/json',
//       },
//       body: JSON.stringify(newEntry),
//     };

//     fetch("https://shopping-site-backend-13q4.onrender.com/api/register", params)
//       .then((res) => res.json())
//       .then((data) => {
//         if (data.message !== "Registration successful") {
//           return window.alert(data.message || "Registration failed");
//         }
//         window.alert("Registration successful");
//         // Assuming the API returns a token on successful registration
//         register(data.token);
//         navigate('/login');
//       })
//       .catch((error) => {
//         console.error(error);
//         window.alert("Error occurred during registration");
//       });
//   };

//   return (
//     <div className="container my-3 py-3">
//       <h1 className="text-center">Register</h1>
//       <hr />
//       <div className="row my-4 h-100">
//         <div className="col-md-4 col-lg-4 col-sm-8 mx-auto">
//           <form onSubmit={handleSubmit}>
//             <div className="form my-3">
//               <label htmlFor="Name">Full Name</label>
//               <input
//                 type="text"
//                 className="form-control"
//                 id="Name"
//                 placeholder="Enter Your Name"
//                 value={fullname}
//                 onChange={(e) => setFullName(e.target.value)}
//               />
//             </div>
//             <div className="form my-3">
//               <label htmlFor="Email">Email address</label>
//               <input
//                 type="email"
//                 className="form-control"
//                 id="Email"
//                 placeholder="name@example.com"
//                 value={email}
//                 onChange={(e) => setEmail(e.target.value)}
//               />
//             </div>
//             <div className="form my-3">
//               <label htmlFor="Password">Password</label>
//               <input
//                 type="password"
//                 className="form-control"
//                 id="Password"
//                 placeholder="Password"
//                 value={password}
//                 onChange={(e) => setPassword(e.target.value)}
//               />
//             </div>
//             <div className="my-3">
//               <p>Already have an account? <Link to="/login" className="text-decoration-underline text-info">Login</Link></p>
//             </div>
//             <div className="text-center">
//               <button className="my-2 mx-auto btn btn-dark" type="submit">
//                 Register
//               </button>
//             </div>
//           </form>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Register;



// import React, { useState, useContext } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import { AuthContext } from "../context/AuthContext";

// const Register = () => {
//   const [fullname, setFullName] = useState("");
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const navigate = useNavigate();
//   const { register, logout } = useContext(AuthContext);

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     const newEntry = { fullname, email, password };

//     if (fullname === '' || email === '' || password === '') {
//       return window.alert("Please fill out all the fields first");
//     }

//     const params = {
//       method: 'post',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify(newEntry),
//     };

//     fetch(" https://shopping-site-backend-m1ok.onrender.com/api/register", params)
//       .then((res) => res.json())
//       .then((data) => {
//         if (data.message !== "Registration successful") {
//           return window.alert(data.message || "Registration failed");
//         }
//         window.alert("Registration successful");
//         register(data.token);
//         logout(); // Clear authentication state
//         navigate('/login');
//       })
//       .catch((error) => {
//         console.error(error);
//         window.alert("Error occurred during registration");
//       });
//   };

//   return (
//     <div className="container my-3 py-3">
//       <h1 className="text-center">Register</h1>
//       <hr />
//       <div className="row my-4 h-100">
//         <div className="col-md-4 col-lg-4 col-sm-8 mx-auto">
//           <form onSubmit={handleSubmit}>
//             <div className="form my-3">
//               <label htmlFor="Name">Full Name</label>
//               <input
//                 type="text"
//                 className="form-control"
//                 id="Name"
//                 placeholder="Enter Your Name"
//                 value={fullname}
//                 onChange={(e) => setFullName(e.target.value)}
//               />
//             </div>
//             <div className="form my-3">
//               <label htmlFor="Email">Email address</label>
//               <input
//                 type="email"
//                 className="form-control"
//                 id="Email"
//                 placeholder="name@example.com"
//                 value={email}
//                 onChange={(e) => setEmail(e.target.value)}
//               />
//             </div>
//             <div className="form my-3">
//               <label htmlFor="Password">Password</label>
//               <input
//                 type="password"
//                 className="form-control"
//                 id="Password"
//                 placeholder="Password"
//                 value={password}
//                 onChange={(e) => setPassword(e.target.value)}
//               />
//             </div>
//             <div className="my-3">
//               <p>Already have an account? <Link to="/login" className="text-decoration-underline text-info">Login</Link></p>
//             </div>
//             <div className="text-center">
//               <button className="my-2 mx-auto btn btn-dark" type="submit">
//                 Register
//               </button>
//             </div>
//           </form>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Register;


